import { render } from "./AdSense.vue?vue&type=template&id=543cc40e&scoped=true"
import script from "./AdSense.vue?vue&type=script&lang=js"
export * from "./AdSense.vue?vue&type=script&lang=js"

import "./AdSense.vue?vue&type=style&index=0&id=543cc40e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543cc40e"]])

export default __exports__